import customSelect from 'custom-select';
import TweenLite from "gsap/gsap-core";
import { Quart } from "gsap/gsap-core";

export default class CustomSelect {

  constructor(pageScroller) {
    this.isInitialising = false;
  }

  init(pageScroller) {
    const mySelect = customSelect(document.querySelector('.wpcf7-select'))[0];

    const list = document.getElementsByClassName("custom-select-panel")[0];

    if (list == null)
      return;

    list.getElementsByClassName("custom-select-option ")[0].remove();
    list.addEventListener("mouseenter", () => pageScroller.pauseSmoothScroll(true));
    list.addEventListener("mouseleave", () => pageScroller.pauseSmoothScroll(false));

    mySelect.container.addEventListener("custom-select:open", async function (e) {
      let daySelect = document.querySelector('[name="jour"]')
      let monthSelect = document.querySelector('[name="mois"]')
      let span = document.querySelector('[data-name="heure"]')

      if (daySelect.value != '' && monthSelect.value != '' && daySelect.value < 32 && monthSelect.value < 13) {
        if (span.classList.contains('error')) {
          span.classList.remove('error')
        }
        let date = new Date(monthSelect.value.trim() + '/' + daySelect.value.trim() + '/' + new Date().getFullYear())
        let currentDate = new Date()
        if (date < currentDate) {
          date.setFullYear(date.getFullYear() + 1)
        }
        let dateFormatted = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()
        let day = date.getDay()
        let dateFormattedCompare = dateFormatted.replaceAll('-', '/')
        let dayFormatted = ''
        switch (day) {
          case 1:
            dayFormatted = 'lundi'
            break;
          case 2:
            dayFormatted = 'mardi'
            break;
          case 3:
            dayFormatted = 'mercredi'
            break;
          case 4:
            dayFormatted = 'jeudi'
            break;
          case 5:
            dayFormatted = 'vendredi'
            break;
          case 6:
            dayFormatted = 'samedi'
            break;
          case 0:
            dayFormatted = 'dimanche'
            break;
        }
        if (dayFormatted == 'dimanche') {
          span.classList.add('errorSunday')
          return;
        } else {
          if (span.classList.contains('errorSunday')) {
            span.classList.remove('errorSunday')
          }
          await setTimeout(() => {
            TweenLite.to(mySelect.panel, 0.666, {
              height: "8em",
              ease: Quart.easeOut
            });
          },500);
        }
      } else {
        span?.classList.add('error');
      }
    });

    mySelect.container.addEventListener("custom-select:close", function (e) {
      TweenLite.to(mySelect.panel, 0.666, { height: 0, ease: Quart.easeOut });
    });
    this.isInitialising = true;
  }

  destroy() {
    let span = document.querySelector('[data-name="heure"]')
    let options = document.querySelectorAll('option');
    let arrayTab = ["Heure"]
    options.forEach(element => {
      if (element.value != '') {
        arrayTab.push(element.innerText)
      }
    });

    let select = document.createElement("select")
    select.name = "heure"
    select.classList.add("wpcf7-form-control","wpcf7-select","wpcf7-validates-as-required","form-select")
    select.setAttribute("aria-required", "true")
    select.setAttribute("aria-invalid", "false")
    select.setAttribute("tabindex", "-1")

    for (let i = 0; i < arrayTab.length; i++) {
      let option = document.createElement("option")
      option.value = arrayTab[i]
      option.text = arrayTab[i]
      select.appendChild(option)
    }

    if (span != null) {
      span.appendChild(select)
    }

    let containerDesroy = document.querySelector('.custom-select-container.customSelect')?.remove();
  }
}